import {
  AfterViewInit,
  Component,
  ContentChild,
  Input,
  HostBinding
} from '@angular/core';

import { LMDrawerContentComponent } from '@drawer/lm-drawer-content/lm-drawer-content.component';
import { LMDrawerSideComponent } from '@drawer/lm-drawer-side/lm-drawer-side.component';

@Component({
  selector: 'lm-drawer',
  template: '<ng-content></ng-content>',
  styleUrls: ['./lm-drawer.component.scss']
})
export class LMDrawerComponent implements AfterViewInit {

  @ContentChild(LMDrawerSideComponent) side: LMDrawerSideComponent;
  @ContentChild(LMDrawerContentComponent) content: LMDrawerContentComponent;

  @Input() showDetails = false;
  @Input() showDetailsOnSide = false;
  @Input() additionalClasses: string[];

  @HostBinding('class') get classes(): string {
    let classNames: string[] = [];

    if (this.showDetails) {
      // enterprise's _list-detail.scss that
      // shows detail area in responsive view
      classNames.push('show-detail');
    }

    if (this.showDetailsOnSide) {
      // enterprise's _layouts.scss for sidebar & content
      classNames.push('two-column fixed-mm');
    }

    if (this.additionalClasses.length) {
      classNames = [...classNames, ...this.additionalClasses];
    }

    return classNames.length ? classNames.join(' ') : '';
  }

  ngAfterViewInit() {
    // Mandatory child components:
    if (!this.side) {
      throw 'LMDrawerSideComponent not found'
    }

    if (!this.content) {
      throw 'LMDrawerContentComponent not found'
    }
  }
}
